import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo">
          <div className="logo-text">
            <h1>🐾 Woofly</h1>
            <span className="tagline">Paws United</span>
          </div>
        </Link>
        
        <nav className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <Link 
            to="/" 
            className={`nav-link ${isActive('/') ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            Home
          </Link>
          <Link 
            to="/ngos" 
            className={`nav-link ${isActive('/ngos') ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            NGO Directory
          </Link>
          <Link 
            to="/dogs" 
            className={`nav-link ${isActive('/dogs') ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            Dogs
          </Link>
          <Link 
            to="/brands" 
            className={`nav-link ${isActive('/brands') ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            Brand Partnerships
          </Link>
          <Link 
            to="/about" 
            className={`nav-link ${isActive('/about') ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            About Us
          </Link>
          <Link 
            to="/how-to-help" 
            className={`nav-link ${isActive('/how-to-help') ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            How to Help
          </Link>
        </nav>

        <div className="hamburger" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </header>
  );
};

export default Header; 